import React from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";

import wrapWithProvider from "./wrap-with-provider";
import { Security } from "@okta/okta-react";
import { OktaAuth } from "@okta/okta-auth-js";
import { oktaConfig } from "./src/config/oktaconfig";


// Gatsby SSR hydration fix
export function replaceHydrateFunction() {
  return (element, container, callback) => {
    ReactDOM.render(element, container, callback);
  };
}

// Initialize Okta Auth
const oktaAuth = new OktaAuth(oktaConfig);

// Combine Redux Provider + Okta Security
export const wrapRootElement = ({ element }) => {
  const wrapped = wrapWithProvider({ element });

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    if (typeof window !== "undefined") {
      // Use relativeToAbsoluteUrl helper
      const relativeUrl = originalUri ? new URL(originalUri, window.location.origin).pathname : "/";
      window.location.replace(relativeUrl);
    }
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {wrapped}
    </Security>
  );
};